import { render, staticRenderFns } from "./demandrecAddOrEdit.vue?vue&type=template&id=18917ce7&scoped=true&"
import script from "./demandrecAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./demandrecAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./demandrecAddOrEdit.vue?vue&type=style&index=0&id=18917ce7&prod&lang=scss&"
import style1 from "./demandrecAddOrEdit.vue?vue&type=style&index=1&id=18917ce7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18917ce7",
  null
  
)

export default component.exports